/* 
  请求打印数据
  create by 李智惠 2021-04-28
*/
import { drugSmallTicket, drug } from "@/api/drugpayment"; // 获取中药处方划价请求
import { comboSmallTicket, combo } from "@/api/combopayment"; // 获取隐秘处方划价请求
import { physioSmallTicket, physio } from "@/api/physiopayment"; // 获取理疗处方划价请求
import { logisticsTC, logisticsSF, getRecipePrint } from "@/api/history"; // 获取病历请求
import { reverseDrug, deliveryDrugTC, deliveryDrugSF } from "@/api/drugpayment"; // 中药处方划价请求
import { reverseCombo, deliveryComboTC, deliveryComboSF } from "@/api/combopayment"; // 隐秘处方划价请求

/* 中药处方模块 开始 */
// 中药处方划价单小票打印
export async function printDrugSmallTicket(obj) {
  console.log(obj, 2222);
  let { code, data } = await drugSmallTicket(obj.orderPaymentRecipeDrugId);
  if (code == 200) {
    // data.unitWeight = Math.round(data.weight / data.doseNumber * 100) / 100;
    data.unitWeight = this.$bigNumber(data.weight, '/', data.doseNumber, 2);
    data.ingredientsAmount = data.ingredients.length;
    // data.deliveryPrice = Math.round(Number(data.deliveryPrice) * 100) / 100;
    data.deliveryPrice = this.$toFixed(data.deliveryPrice);
    // data.procssingPrice = Math.round(Number(data.procssingPrice) * 100) / 100;
    data.procssingPrice = this.$toFixed(data.procssingPrice);
    this.$computeAge(data.birthday, data);
    this.drugTicketObj = data;
    this.drugTicketVisible = true;
  }
}

// 中药处方扭转单打印
export async function printDrugReverse(obj) {
  let { code, data } = await reverseDrug(obj.orderPaymentRecipeDrugId);
  if (code == 200) {
    this.$computeAge(data.patientBirthday, data);
    this.reverseDrugObj = data;
    this.reverseDrugVisible = true;
  }
}

// 中药处方打印
export async function printDrug(recipeId, type) {
  let param = { recipeId, type }
  let { code, data } = await getRecipePrint(param);
  if (code == 200) {
    data.payWay = "";
    // if (type == '1') data.charges.forEach(item => { data.payWay += item.payWay + ' ' });
    this.$computeAge(data.birthday, data);
    switch (data.doseType) {
      case '0': data.doseTypeStr = '中药饮片'; break;
      case '1': data.doseTypeStr = '中药颗粒'; break;
      case '2': data.doseTypeStr = '中药饮片、中药颗粒'; break;
    }
    this.drugObj = data;
    this.drugVisible = true;
  }
}

// 中药处方同城快递单打印
export async function printDrugIntraCity(obj) {
  let { code, data } = await deliveryDrugTC(obj.orderPaymentRecipeDrugId);
  if (code == 200) {
    data.payWay = '';
    data.recipeDrugCharges.forEach(item => {
      data.payWay += `${item.payWay}(${item.payPrice} 元)`;
    });
    this.intraCityObj = data;
    this.intraCityVisible = true;
  }
}

// 中药处方顺丰快递单打印
export async function printDrugShunFeng(obj) {
  let { code, data } = await deliveryDrugSF(obj.orderPaymentRecipeDrugId);
  if (code == 200) {
    this.shunFengObj = data;
    this.shunFengVisible = true;
  }
}
/* 中药处方模块 开始 */

/* 隐秘处方模块 开始 */
// 隐秘处方划价单小票打印
export async function printComboSmallTicket(obj) {
  let { code, data } = await comboSmallTicket(obj.paymentRecipeComboId);
  if (code == 200) {
    // data.unitWeight = Math.round(data.weight / data.doseNumber * 100) / 100;
    data.unitWeight = this.$bigNumber(data.weight, '/', data.doseNumber, 2);
    // data.deliveryPrice = Math.round(Number(data.deliveryPrice) * 100) / 100;
    data.deliveryPrice = this.$toFixed(data.deliveryPrice);
    this.$computeAge(data.birthday, data);
    this.comboTicketObj = data;
    this.comboTicketVisible = true;
  }
}

// 隐秘处方扭转单打印
export async function printComboReverse(obj) {
  let { code, data } = await reverseCombo(obj.paymentRecipeComboId);
  if (code == 200) {
    this.$computeAge(data.patientBirthday, data);
    this.reverseComboObj = data;
    this.reverseComboVisible = true;
  }
}

// 隐秘处方打印
export async function printCombo(recipeId, type) {
  let param = { recipeId, type }
  let { code, data } = await getRecipePrint(param);
  if (code == 200) {
    data.payWay = "";
    // if (type == '1') data.charges.forEach(item => { data.payWay += item.payWay + ' ' });
    this.$computeAge(data.birthday, data);
    this.comboObj = data;
    this.comboVisible = true;
  }
}

// 隐秘处方同城快递单打印
export async function printComboIntraCity(obj) {
  let { code, data } = await deliveryComboTC(obj.orderPaymentRecipeComboId);
  if (code == 200) {
    data.payWay = '';
    data.recipeComboCharges.forEach(item => {
      data.payWay += `${item.payWay}(${item.payPrice} 元)`;
    });
    this.intraCityObj = data;
    this.intraCityVisible = true;
  }
}

// 隐秘处方顺丰快递单打印
export async function printComboShunFeng(obj) {
  let { code, data } = await deliveryComboSF(obj.orderPaymentRecipeComboId);
  if (code == 200) {
    this.shunFengObj = data;
    this.shunFengVisible = true;
  }
}
/* 隐秘处方模块 开始 */

/* 理疗处方模块 开始 */
// 理疗处方划价单小票打印
export async function printPhysioSmallTicket(obj) {
  let { code, data } = await physioSmallTicket(obj.orderPaymentRecipePhysioId);
  if (code == 200) {
    this.$computeAge(data.birthday, data);
    this.physioTicketObj = data;
    this.physioTicketVisible = true;
  }
}

// 理疗处方打印
export async function printPhysio(recipeId, type) {
  let param = { recipeId, type }
  let { code, data } = await getRecipePrint(param);
  if (code == 200) {
    data.payWay = "";
    // if (type == '1') data.charges.forEach(item => { data.payWay += item.payWay + ' ' });
    this.$computeAge(data.birthday, data);
    this.physioObj = data;
    this.physioVisible = true;
  }
}
/* 理疗处方模块 开始 */

// 执行打印
export function printBox(box) {
  let printHtml = document.querySelector('#' + box).innerHTML;
  let wind = window.open("", 'newwindow', 'height=auto, width=100, top=100, left=100, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, recipeStatus=no');
  wind.document.body.innerHTML = printHtml;
  wind.print();
  return false;
}

// 获取物流跟踪信息
export async function getLogisticsData(obj, orderType) {
  this.companyName = obj.companyName;
  let type = null, status = null;
  if (orderType == '中药处方划价单') {
    type = 1;
    status = 7;
  } else {
    type = 2;
    status = 6;
  }
  if (obj.companyName == '同城快递') {
    let { code, data } = await logisticsTC(obj.orderPaymentRecipeDrugId, status, { orderType: type });
    if (code == 200) {
      data.list.push({ scanTime: data.createTime, remark: '订单生成成功，等待配送！' })
      this.Logistics = data.list;
      this.dialogLogistics = true;
    }
  } else {
    let { code, data } = await logisticsSF(obj.orderNumber);
    if (code == 200) {
      let list = [];
      data.data[0].routes.forEach(item => {
        list.push({ scanTime: item.acceptTime, remark: item.remark });
      });
      this.Logistics = list;
      this.dialogLogistics = true;
    }
  }
}

